import * as React from "react";
import "./DocumentSectionLinkComponent.css";
import { HRSectionId } from "../../messages/ObjectIds";
import { Button, Intent } from "@blueprintjs/core";

interface DocumentSectionLinkComponentProps {
    sectionId: HRSectionId;
    isClicked: boolean;
    title: string;
    onClick: () => void;
}

export class DocumentSectionLinkComponent extends React.Component<DocumentSectionLinkComponentProps> {
    constructor(props: DocumentSectionLinkComponentProps) {
        super(props);
    }

    render() {
        return (
            <Button
                intent={this.props.isClicked ? Intent.SUCCESS : Intent.PRIMARY}
                onClick={this.props.onClick}
                className={"DocumentSectionLinkComponent__root"}
            >
                <div className={"DocumentSectionLinkComponent__container"}>
                    <div className={"DocumentSectionLinkComponent__pictureIcon DocumentSectionLinkComponent__pictureIconWhite"} />
                    {this.props.title}
                </div>
            </Button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/DocumentSectionLinkComponent.tsx